import { useDonationFormContext } from '../../DonationFormProvider'
import PageCheckBox from './PageCheckBox'
import { useShallow } from 'zustand/react/shallow'
import { useEffect } from 'react'
import { formatDonorPaysWording } from '../../donorPaysWording'

type DonorPaysCheckboxProps = {
  donorPaysAmount: number
}

const DonorPaysCheckbox = ({ donorPaysAmount }: DonorPaysCheckboxProps) => {
  const { formValues, setFormValues, donorPaysWording } = useDonationFormContext(
    useShallow(({ formValues, actions, settings }) => ({
      formValues,
      setFormValues: actions.setFormValues,
      donorPaysWording: settings.styles?.options?.donorPaysWording as string | undefined,
    })),
  )
  const { isDonorPays } = formValues

  useEffect(() => {
    setFormValues({ isDonorPays: true })
  }, [])

  return (
    <PageCheckBox
      id="donor-pays"
      label={formatDonorPaysWording(donorPaysWording, donorPaysAmount)}
      isChecked={isDonorPays ?? true}
      onChange={(value) => setFormValues({ ...formValues, isDonorPays: value })}
    />
  )
}

export default DonorPaysCheckbox
